(function($){
  $(document).on('ready', function () {
    $(".ns-parallax-container__img").stick_in_parent();
  });
})(jQuery);
